module.exports = __webpack_public_path__ + "img/ziti_01.0d44f346.png";